var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckPercent = function SvgCheckPercent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9ED495",
    d: "M10.597.785a10.348 10.348 0 1 1 0 20.697 10.348 10.348 0 0 1 0-20.697"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.17 9.43c0 1.325-.915 2.384-2.266 2.384-1.338 0-2.238-1.046-2.238-2.358 0-1.324.914-2.384 2.265-2.384 1.337 0 2.238 1.047 2.238 2.358m4.768-2.252L8.169 16.45H6.593l6.768-9.272zm.927 6.994c0 1.324-.914 2.384-2.265 2.384-1.338 0-2.239-1.046-2.239-2.358 0-1.324.914-2.384 2.265-2.384 1.338 0 2.239 1.047 2.239 2.358M8.778 9.456c0-.635-.344-1.178-.874-1.178-.556 0-.848.53-.848 1.152 0 .636.345 1.179.875 1.179.556 0 .847-.53.847-1.153m5.696 4.742c0-.635-.344-1.178-.874-1.178-.556 0-.848.53-.848 1.152 0 .636.345 1.179.874 1.179.557 0 .848-.53.848-1.153"
  })));
};
export default SvgCheckPercent;